import { cn } from '@commenda/utils';
import React from 'react';

interface IRadioInput extends React.InputHTMLAttributes<HTMLInputElement> {
  label: React.ReactNode | string;
  id: string;
  checked: boolean;
  onCheck: React.Dispatch<React.SetStateAction<boolean>>;
  _css?: string;
}

const RadioInput = ({
  label,
  id,
  checked,
  _css,
  onCheck,
  disabled,
  ...restProps
}: IRadioInput) => {
  return (
    <div className={cn('flex py-2 space-x-3 items-center', _css)}>
      <input
        type="radio"
        className={cn(
          'h-4 w-4 border-gray-300 text-fg-secondary ring-0 active:ring-0 focus:ring-0 cursor-pointer',
          disabled &&
            'cursor-not-allowed opacity-50 bg-fg-disabled border-border-disabled' // Add disabled styles
        )}
        aria-describedby={typeof label === 'string' ? label : undefined}
        checked={checked}
        onChange={(e) => onCheck(e.target.checked)}
        id={id}
        disabled={disabled}
        {...restProps}
      />
      <label
        className="text-sm text-text-secondary whitespace-pre-line"
        htmlFor={id}
      >
        {label}
      </label>
    </div>
  );
};

export default RadioInput;
